import React, { useState } from 'react';
import clsx from 'clsx';
import type { GalleryMedia } from '../../types';
import styles from './MobileCarousel.module.css';

interface ProgressiveSlideImageProps {
  img: GalleryMedia;
  isActive: boolean;
}

export const ProgressiveSlideImage: React.FC<ProgressiveSlideImageProps> = React.memo(({ img, isActive }) => {
  const [loaded, setLoaded] = useState(false);
  const hasThumbnail = !!img.thumbnailUrl && img.thumbnailUrl !== img.url;
  const showFullRes = isActive || loaded;

  return (
    <div className={styles.progressiveImageWrapper}>
      {hasThumbnail && (
        <img
          src={img.thumbnailUrl}
          alt={img.title}
          className={clsx(styles.mobileImage, styles.thumbnailLayer)}
          crossOrigin="anonymous"
        />
      )}
      {(isActive || loaded) && (
        <img
          src={img.url}
          alt={img.title}
          className={clsx(
            styles.mobileImage,
            hasThumbnail && styles.fullResLayer,
            loaded && styles.fullResLoaded,
          )}
          loading="lazy"
          onLoad={() => setLoaded(true)}
          crossOrigin="anonymous"
        />
      )}
      {!hasThumbnail && !showFullRes && (
        <img src={img.url} alt={img.title} className={styles.mobileImage} loading="lazy" crossOrigin="anonymous" />
      )}
    </div>
  );
});

ProgressiveSlideImage.displayName = 'ProgressiveSlideImage';
